export const S = {
  AUDIO: "AUDIO",
  CREATED_DATE: "CREATED DATE",
  CREATOR: "CREATOR",
  HAS_SPEECH_ANNOTATION: "HAS SPEECH ANNOTATION",
  LANGUAGE_ID: "LANGUAGE_ID",
  LANGUAGE_VOICE_TEXT_HASH: "LANGUAGE VOICE TEXT HASH",
  LINK: "LINK",
  NO_SPEECH_ANNOTATION: "NO SPEECH ANNOTATION",
  NO_SSML: "NO SSML",
  REGENERATE_AUDIO: "REGENERATE AUDIO",
  SPEED: "SPEED",
  SSML: "SSML",
  TEXT: "TEXT",
  TTS_HASH: "TTS HASH",
  VOICE: "VOICE",
};
